import * as moment from 'moment';
import { Modal, Button } from 'react-bootstrap';
import { DonationType } from '@nkr/enums/donation-type';
import { Utility } from '@nkr/services/utility';

interface IAlertProps {
    show: boolean;
    startExportDate?: string;
    donationStartDate?: string;
    donationEndDate?: string;
    donationType?: number;
    isChainStarter?: boolean;
    totalBusinessDays?: number;
    onClose: () => void;
}

const DonationRangeAlert = (props: IAlertProps) => {
    const hasDates = props.donationStartDate && props.donationEndDate
    const startBeforeBeforeExportDate = moment(props.donationStartDate, 'MM/DD/YYYY').isBefore(moment(props.startExportDate, 'MM/DD/YYYY'));

    return (
        <Modal
            show={props.show}
            onHide={props.onClose}
            bsSize='medium'
            backdrop='static'
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ color: '#c9372e', fontWeight: 'bold' }}>
                    ALERT
                    {hasDates && !startBeforeBeforeExportDate && (
                        <span>
                            &nbsp;: You selected a date range of <span style={{ fontWeight: 'bold' }}>{props.totalBusinessDays}</span> business day(s).
                        </span>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ color: '#c9372e', fontWeight: 'bold', marginBottom: 10 }}>
                    Donation range selection rules:
                </div>
                <div style={{ lineHeight: '1.6' }}>
                    {props.isChainStarter && (
                        <>
                            <div>
                                <strong>Chain Starter:</strong> Donation must begin at least 15 business days from exportability date.
                            </div>
                        </>
                    )}

                    {props.donationType == DonationType.FamilyVoucher && (() => {
                        const earliest = props.startExportDate;
                        const donationStart = props.donationStartDate; // assuming this exists

                        let baseDate = earliest;

                        if (donationStart) {
                            const donationDate = new Date(donationStart);
                            const earliestDate = new Date(earliest);

                            if (donationDate > earliestDate) {
                                baseDate = donationStart;
                            }
                        }

                        return (
                            <div style={{ marginTop: 10, marginLeft: 24 }}>
                                <div>
                                    <strong>Family Voucher:</strong> Donation must be between 5 and 15 business days.
                                </div>
                                <div>
                                    <strong>Earliest Allowed Donation Date: </strong>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        {earliest}
                                    </span>
                                </div>
                                <div>
                                    <strong>Latest Allowed Donation Date: </strong>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        {Utility.addBusinessDaysFormatted(baseDate, 15)}
                                    </span>
                                </div>
                            </div>
                        );
                    })()}

                    {props.donationType == DonationType.StandardVoucher && (() => {
                        const earliest = props.startExportDate;
                        const donationStart = props.donationStartDate;

                        let baseDate = earliest;

                        if (donationStart) {
                            const donationDate = new Date(donationStart);
                            const earliestDate = new Date(earliest);

                            if (donationDate > earliestDate) {
                                baseDate = donationStart;
                            }
                        }

                        return (
                            <div style={{ marginTop: 10, marginLeft: 24 }}>
                                <div>
                                    <strong>Standard Voucher:</strong> Donation must be between 15 and 30 business days.
                                </div>
                                <div>
                                    <strong>Earliest Allowed Donation Date: </strong>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        {earliest}
                                    </span>
                                </div>
                                <div>
                                    <strong>Latest Allowed Donation Date: </strong>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        {Utility.addBusinessDaysFormatted(baseDate, 30)}
                                    </span>
                                </div>
                            </div>
                        );
                    })()}


                    {props.donationType == DonationType.NonDirectedDonor && (() => {
                        const earliest = props.startExportDate;
                        const donationStart = props.donationStartDate;

                        let baseDate = earliest;

                        if (donationStart) {
                            const donationDate = new Date(donationStart);
                            const earliestDate = new Date(earliest);

                            if (donationDate > earliestDate) {
                                baseDate = donationStart;
                            }
                        }

                        return (
                            <div style={{ marginTop: 10, marginLeft: 24 }}>
                                <div>
                                    <strong>NDD:</strong> Donation must be between 5 and 15 business days.
                                </div>
                                <div>
                                    <strong>Earliest Allowed Donation Date: </strong>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        {earliest}
                                    </span>
                                </div>
                                <div>
                                    <strong>Latest Allowed Donation Date: </strong>
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>
                                        {Utility.addBusinessDaysFormatted(baseDate, 15)}
                                    </span>
                                </div>
                            </div>
                        );
                    })()}
                </div>
                <div style={{ marginTop: 12 }}>
                    <em>* Business days are Monday–Friday (excluding weekends).</em>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DonationRangeAlert;
